import { CircularProgress, IconButton } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addDoc, collection } from "firebase/firestore";
import { db } from "firebaseApp";
import { modalsActions } from "store/react-lib/generic-ui/modals";
import AttachFileModal from "components/attachments/AttachFileModal";
import AddLinkIcon from '@mui/icons-material/AddLink';
import toast from "react-hot-toast";

const MODAL_NAME = "attachFileModal";

export default function AttachFileIconButton({
  targetId,
  modalTitle = "",
  ...props
}) {
  
  const dispatch = useDispatch();
  const [attaching, setAttaching] = useState(false);

  const handleOpen = async () => {
    try {
      dispatch(modalsActions.openModal(MODAL_NAME));
    } catch (error) {
      console.log(error);
    }
  };

  const attachFileToTarget = async ({ fileId, fileData }) => {
    if(!targetId) return;
    try {
      setAttaching(true);
      const payload = {
        ...fileData,
        fileId,
        targetId,
        createdAt: new Date().getTime(),
      };
      await addDoc(collection(db, "attachments"), payload);
      dispatch(modalsActions.closeModal(MODAL_NAME));
      toast.success("Attachment created!")
    } catch (error) {
      console.log(error);
      toast.error("Couldn't attach file. Try again later.");
    } finally {
      setAttaching(false);
    }
  };

  return (
    <>
      <AttachFileModal
        title={modalTitle}
        name={MODAL_NAME}
        successCallback={attachFileToTarget}
      />
      <IconButton
        onClick={handleOpen}
        data-testid="attach-file-button"
        {...props}
        disabled={attaching || !targetId}
      >
        {attaching ? <CircularProgress size={24} /> : <AddLinkIcon />}
      </IconButton>
    </>
  );
}
